import { render, staticRenderFns } from "./PanoramaBlock.vue?vue&type=template&id=f8651282&scoped=true&"
import script from "./PanoramaBlock.vue?vue&type=script&lang=js&"
export * from "./PanoramaBlock.vue?vue&type=script&lang=js&"
import style0 from "./PanoramaBlock.vue?vue&type=style&index=0&id=f8651282&lang=scss&"
import style1 from "./PanoramaBlock.vue?vue&type=style&index=1&id=f8651282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8651282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8651282')) {
      api.createRecord('f8651282', component.options)
    } else {
      api.reload('f8651282', component.options)
    }
    module.hot.accept("./PanoramaBlock.vue?vue&type=template&id=f8651282&scoped=true&", function () {
      api.rerender('f8651282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/PanoramaBlock.vue"
export default component.exports